module.exports = __webpack_public_path__ + "static/img/s07.55aacaa9.png";